import axios from 'axios';

export const api = axios.create({
	baseURL: process.env.REACT_APP_SUPERGER_API_URL,
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'multipart/form-data',
	}
})

/**
 * 401 em qualquer rota autenticada = token recusado pela API (expirado, chave rotacionada, sessao derrubada).
 * Limpa a sessao e volta para o login em vez de deixar as telas falhando ate o cliente sair manualmente.
 * O /login e o /login/verificar-codigo ficam de fora: neles o erro e tratado pela propria tela.
 */
api.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		const url: string = error?.config?.url || '';
		const rotaDeLogin = url.includes('/login');
		if (status === 401 && !rotaDeLogin && localStorage.getItem('session_netcomet')) {
			localStorage.removeItem('session_netcomet');
			localStorage.removeItem('session_netcomet_token');
			localStorage.removeItem('session_netcomet_topics');
			window.location.href = '/';
		}
		return Promise.reject(error);
	}
);
